import { UserQuestionsData } from 'common/types/Community'
import { AppState } from 'web/store'

export const getUserQuestions = () => (state: AppState): UserQuestionsData => {
  const { userQuestions } = state.community.data
  return userQuestions
}
